<template>
    <div class="generate-img" :class="{ 'see-layout' : testGenerator }">
		<button class="btn" @click="generatePdf()">
			Download File
		</button>

		<section ref="imgContent">
			<slot name="img-content"/>
		</section>
    </div>
</template>
<script>
import html2pdf from 'html2pdf.js'
import JsPDF from 'jspdf'

export default {
	props: {
		testGenerator: {
			type: Boolean,
			default: false
		},

		splitImgByHeight: {
			type: String,
			default: ''
		},

		filename: {
			type: String,
			default: 'Upmood-Report'
		}
	},

	data () {
		return {
			hasAlreadyParsed: false,
			progress: 0,
			pages: []
		}
	},

	watch: {
		progress (val) {
			this.$emit('progress', Math.floor(val * 10) / 10)
		}
	},

	methods: {
		async generatePdf () {
			this.progress = 0

			await this.groupElementsBySplitImgHeightProp()

			this.downloadPDF()
		},

		async groupElementsBySplitImgHeightProp () {
			this.progress = 25

			if (!this.hasAlreadyParsed) {
				const parentElement = this.$refs.imgContent.firstChild
				const ArrOfContentChildren = [...parentElement.children]

				// let elementsPerPage = [[]]
				let childrenHeight = 0

				const tempProgress = 25

				/*
					Collect child elements and give them a parent
					element which will represent as page.

					Continuously Add Elements to a "page" until
					The element's height inside the elementsPerPage array is <= to the
					SplitImgHeight prop value else add to the next page,
					And repeat same process
				*/

				ArrOfContentChildren.forEach((childElement, index) => {
					const elementHeight = childElement.clientHeight
					const pageLength = this.pages.length

					if ((childrenHeight + elementHeight) < this.splitImgByHeight) {
						if (!pageLength) {
							this.pages.push([childElement])
						} else {
							this.pages[pageLength - 1].push(childElement)
						}

						childrenHeight += elementHeight
					} else {
						childElement.style.borderColor = '#fff'

						this.pages.push([childElement])

						// Reset Variables made the upper condition false
						childrenHeight = elementHeight
					}

					this.progress = tempProgress + ((index / (ArrOfContentChildren.length - 1)).toFixed(1) * 25)
				})

				/*
					Set to true so that if would generate again we wouldn't need
					to parse the HTML to paginate the elements
				*/
				this.hasAlreadyParsed = true
			}
		},

		async downloadPDF () {
			const doc = new JsPDF()
			const percentPerPage = (49 / this.pages.length)

			for (const [index, value] of this.pages.entries()) {
				this.progress += parseFloat(percentPerPage)

				const section = await this.appendPageToSection(value)

				const width = doc.internal.pageSize.getWidth()
				const height = doc.internal.pageSize.getHeight()

				const [ pageImage, pdfHeight ] = await Promise.all([
					this.setPageImage(section),
					this.calculateHeight(height, section.clientHeight)
				])

				doc.addImage(pageImage.src, 'jpeg', 8, 10, width - 15.5, pdfHeight)

				if (this.pages.length === (index + 1)) {
					await doc.save(`${this.filename}.pdf`)

					this.progress = 100

					this.$emit('hasDownloaded')
				} else {
					doc.addPage()
				}
			}
		},

		appendPageToSection (page) {
			const parentElement = this.$refs.imgContent.firstChild
			const section = document.createElement('section')

			parentElement.appendChild(section)

			page.forEach(pageElement => {
				section.appendChild(pageElement)
			})

			const placeholder = document.createElement('section')

			placeholder.style.width = '100%'
			placeholder.style.height = `${this.splitImgByHeight - section.clientHeight}px`

			section.appendChild(placeholder)

			return section
		},

		async setPageImage (section) {
			const opt = {
				// html2canvas: { scale: 1.3 }
				html2canvas: { scale: 3 }
			}

			const pageImage = await html2pdf().from(section).set(opt).outputImg()

			return pageImage
		},

		calculateHeight (pdfPageHeight, sectionHeight) {
			const pdfHeightPercentage = pdfPageHeight / this.splitImgByHeight
			// const sectionCalculatedHeight = (sectionHeight - 180) * pdfHeightPercentage
			const sectionCalculatedHeight = (sectionHeight - 180) * pdfHeightPercentage

			return sectionCalculatedHeight
		}
	}
}
</script>

<style lang="scss" scoped>
.generate-img {
	position: fixed;
	width: 100vw;
	height: 100vh;
	left: -100vw;
	top: 0;
	z-index: -9999;
	background: rgba(95, 95, 95, 0.8);
	display: flex;
	justify-content: center;
	align-items: flex-start;
	overflow: auto;

	.btn {
		display: none;
	}

	&.see-layout {
		left: 0vw;
		z-index: 9999;

		.btn {
			position: fixed;
			display: block;
			left: 10px;
			top: 10px;
			background: #657bdd;
			color: #fff;
			padding: 15px 25px;
		}
	}
}
</style>
